export default {
  lang: {
    selectAll: 'Chọn tất cả các trang',
    selected: 'Đã chọn',
    term: 'Sọc',
    deselect: 'Hủy lựa chọn',
  },
};
